import resolvedVariables from "../../../assets/styles/variablesExport.module.scss";
export default function cssBaseline({ variables }) {
    return {
        MuiCssBaseline: {
            styleOverrides: `
        p, dl, dd { margin: 0; }

        strong, b { font-weight: ${variables.type_emphasis_font_weight}; }

        code, samp, kbd {
          font-family: ${variables.mono_font_family};
          font-size: 0.925em;
        }

        small {
          font-size: ${variables.type_body_sm_font_size};
          line-height: ${variables.type_body_sm_line_height};
        }

        h1 {
          font-size: ${variables.type_title_page_font_size};
          font-weight: ${variables.type_title_page_font_weight};
          line-height: ${variables.type_title_page_line_height};
          letter-spacing: ${variables.type_title_page_letter_spacing};
        }

        h2 {
          font-size: ${variables.type_title_card_font_size};
          font-weight: ${variables.type_title_card_font_weight};
          line-height: ${variables.type_title_card_line_height};
          letter-spacing: ${variables.type_title_card_letter_spacing};
        }

        h3 {
          font-size: ${variables.type_title_section_font_size};
          font-weight: ${variables.type_title_section_font_weight};
          line-height: ${variables.type_title_section_line_height};
          letter-spacing: ${variables.type_title_section_letter_spacing};
        }

        h4, h5, h6 {
          font-size: ${variables.type_title_subsection_font_size};
          font-weight: ${variables.type_title_subsection_font_weight};
          line-height: ${variables.type_title_subsection_line_height};
          letter-spacing: ${variables.type_title_subsection_letter_spacing};
        }

        @property --grad-end {
          syntax: "<color>";
          inherits: false;
          initial-value: ${resolvedVariables.nitro_gradient_end};
        }
      `,
        },
    };
}
//# sourceMappingURL=cssBaseline.js.map